import { render } from "./InputView.vue?vue&type=template&id=ebd4271a&scoped=true"
import script from "./InputView.vue?vue&type=script&lang=js"
export * from "./InputView.vue?vue&type=script&lang=js"

import "./InputView.vue?vue&type=style&index=0&id=ebd4271a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebd4271a"]])

export default __exports__